<template>
  <div class="tab-maintain-order">


    <div class="table-content">
      <div class="header">
        <div class="search-content">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item style="float: right; margin-right: 0" v-if="funcView.account_order_maintain_export">
              <el-button type="info" @click="exportOrder(formSearch)">
                <i class="icon icon-export-excel"></i>
                {{ $t('com_export') }} Excel
              </el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
            </el-form-item>
            <el-form-item style="float: right" :class="!funcView.account_order_maintain_export ? 'mr-0' : ''">
              <custom-column ref="column"></custom-column>
            </el-form-item>
            <el-form-item style="float: right">
              <search-input v-model="formSearch.search" :placeholder="$t('tm_order_ji_shen_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="query-filter">
      <div class="params-form"  v-show="isFilter">
        <el-row :gutter="23">
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('tm_order_zhuang_tai') }}</div>
              <div class="value">
                <custom-select code="asm_work_order_state" v-model="formSearch.caseOrderState" multiple theme="yellow" @change="onStateChange" :placeholder="$t('com_please_select')"></custom-select>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('tm_order_shang_bao_ri_qi') }}</div>
              <div class="value">
                <custom-date-picker v-model="formSearch.gmtCreate" type="daterange" align="right" unlink-panels @change="onDateChange" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('tm_order_xiang_mu') }}</div>
              <div class="value">
                <el-input v-model="formSearch.locationName" @input="onLocationChange" clearable :placeholder="$t('com_please_input')"></el-input>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="23">
          <el-col :span="8" v-if="isCoJv && showSubsidiary">
            <div class="item">
              <div class="label">{{ $t('tm_order_gsmc') }}</div>
              <div class="value">
                <el-input v-model="formSearch.customerName" @input="onCustomerNameChange" clearable :placeholder="$t('com_please_input')"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('tm_order_wcsj') }}</div>
              <div class="value">
                <custom-date-picker v-model="formSearch.finishTime" type="daterange" align="right" unlink-panels value-format="YYYY-MM-DD HH:mm:ss" @change="onFinishTimeChange"></custom-date-picker>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="filter-values">
        <div class="label">{{ $t('tm_order_shai_xuan_xiang') }}：</div>
        <div class="values">
          <el-tag closable v-for="stateTag in stateTagList" :key="stateTag.value" @close="onCloseState(stateTag.value)">{{ stateTag.label }}</el-tag>
          <el-tag closable v-for="dateTag in dateTagList" :key="dateTag.value" @close="onCloseTime(dateTag.value)">{{ dateTag.label }}</el-tag>
          <el-tag closable v-for="finishTimeTag in finishTimeTagList" :key="finishTimeTag.value" @close="onCloseFinishTime(finishTimeTag.value)">{{ finishTimeTag.label }}</el-tag>
          <el-tag closable v-for="locationNameTag in locationNameTagList" :key="locationNameTag.value" @close="onCloseLocationName(locationNameTag.value)">{{ locationNameTag.label }}</el-tag>
          <el-tag closable v-for="customerNameTag in customerNameTagList" :key="customerNameTag.value" @close="onCloseCustomerName(customerNameTag.value)">{{ customerNameTag.label }}</el-tag>
          <span class="clear" @click="onClear">{{ $t('com_clear') }}</span>
        </div>
      </div>
    </div>
      <div class="table-bd">
        <custom-table
          tableCode="portal_case_order_list"
          height="100%"
          :stripe="true"
          :data="tableList"
          @column="setColumn"
          columnRef="column"
          :slots="['action']"
          @on-row-click="onRowClick"
          @filter="filterChange"
          @sort="sortChange"
          :filterArr="!isCoJv ? ['customerName'] : []"
        >
          <template v-slot:action="scope">
            <span>
              <el-button v-if="closeOrderVisible(scope.row) && funcView.account_order_maintain_cancel" type="text" size="mini" @click.stop="onClose(scope.row)">{{ $t('tm_order_qu_xiao_gong_dan') }}</el-button>
            </span>
          </template>
        </custom-table>
      </div>
      <div class="page-footer">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange" radius></custom-pagination>
      </div>
    </div>
    <acceptance-comments-dialog v-if="acceptanceCommentsVisible" @close="acceptanceCommentsVisible = false" :model="acceptanceCommentsModel" @success="onSuccess"></acceptance-comments-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customPagination from '@/components/customPagination';
import mixins from '@/pages/order/children/mixins';
import acceptanceCommentsDialog from '@/pages/order/children/close_order_dialog.vue';

// tm_order_zhuang_tai: 状态// tm_order_shang_bao_ri_qi: 上报日期// tm_order_xiang_mu: 项目// tm_order_gsmc: 公司名称// tm_order_wcsj: 完成时间// tm_order_shai_xuan_xiang: 筛选项// tm_order_qu_xiao_gong_dan: 取消工单// tm_order_ji_shen_hao: 机身号// tm_order_qu_xiao_gong_dan_1: 取消工单

export default {
  name: 'TabRepairOrder',
  mixins: [mixins],
  components: {
    customPagination,
    acceptanceCommentsDialog,
  },
  props: {},
  data() {
    return {
      billType: 'maintainOrder',
      type: '',
      date1: '',
      project: '',
      tableList: [],
      totalRows: 0,
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        locationName: '',
        caseOrderState: [],
        caseOrderType: [],
        gmtCreate: '',
        time: '',
        finishTime: '',
        search: '',
        // 公司名称
        customerName: '',
        showSubsidiary: '',
      },
      stateTagList: [],
      dateTagList: [],
      finishTimeTagList: [],
      locationNameTagList: [],
      customerNameTagList: [],

      acceptanceCommentsVisible: false,
      acceptanceCommentsModel: {},

      tableColumn: [],
      isFilter: false,
    };
  },
  methods: {
    onColumn(data) {
      this.setColumn(data);
      this.tableColumn = data.tableColumn;
    },
    onSuccess() {
      this.onPageChange({ page: 1 });
    },
    // 关闭
    onClose(row) {
      this.acceptanceCommentsModel = {
        title: this.$t('tm_order_qu_xiao_gong_dan_1'),
        data: row,
      };
      this.acceptanceCommentsVisible = true;
    },
    onRowClick(e) {
      const query = {
        caseOrderId: e.caseOrderId,
        caseOrderCode: e.caseOrderCode,
        pageType: 'maintain',
      };
      this.jump('/service/order/detail/detail', query);
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },

    getReqData() {
      const ret = {
        ...this.formSearch,
      };
      if (this.formSearch.gmtCreate && this.formSearch.gmtCreate.length) {
        ret.createStartTime = this.formSearch.gmtCreate[0];
        ret.createEndTime = this.formSearch.gmtCreate[1];
        delete ret.time;
        delete ret.gmtCreate;
      }
      return ret;
    },
    onStateChange(data) {
      if (!data || !data.length) {
        this.stateTagList = [];
      } else {
        this.stateTagList = data.map(item => ({
          label: item.name,
          value: item.value,
          ...item,
        }));
      }
      this.onPageChange({ page: 1 });
    },
    onExport() {
      const reqData = this.getReqData();
      delete reqData.pageNum;
      delete reqData.pageSize;
      this.exportTable('caseOrderExport4Portal', this.getReqData());
    },
    onCloseState(value) {
      this.stateTagList = this.stateTagList.filter(item => item.value !== value);
      this.formSearch.caseOrderState = this.stateTagList.map(item => item.value);
      this.onPageChange({ page: 1 });
    },
    onClear() {
      this.stateTagList = [];
      this.dateTagList = [];
      this.finishTimeTagList = [];
      this.locationNameTagList = [];
      this.customerNameTagList = [];
      this.formSearch.caseOrderState = [];
      this.formSearch.gmtCreate = '';
      this.formSearch.locationName = '';
      this.formSearch.finishTime = '';
      this.formSearch.customerName = '';
      this.onPageChange({ page: 1 });
    },
    onDateChange() {
      const data = this.formSearch.gmtCreate;
      if (data && data.length) {
        const start = this.$momentLocal(data[0], 'YYYY-MM-DD');
        const end = this.$momentLocal(data[1], 'YYYY-MM-DD');
        this.dateTagList = [
          {
            label: `${start} - ${end}`,
            value: 'date',
          },
        ];
      } else {
        this.dateTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseTime() {
      this.formSearch.gmtCreate = [];
      this.onDateChange();
    },
    onFinishTimeChange() {
      const data = this.formSearch.finishTime;
      if (data && data.length) {
        const start = this.$momentLocal(data[0], 'YYYY-MM-DD');
        const end = this.$momentLocal(data[1], 'YYYY-MM-DD');
        this.finishTimeTagList = [
          {
            label: `${start} - ${end}`,
            value: 'date',
          },
        ];
      } else {
        this.finishTimeTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseFinishTime() {
      this.formSearch.finishTime = [];
      this.onFinishTimeChange();
    },
    onLocationChange() {
      const locationName = this.formSearch.locationName.trim();
      if (locationName) {
        this.locationNameTagList = [
          {
            label: locationName,
            value: 'locationName',
          },
        ];
      } else {
        this.locationNameTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseLocationName() {
      this.formSearch.locationName = '';
      this.onLocationChange();
    },
    onCustomerNameChange() {
      const customerName = this.formSearch.customerName.trim();
      if (customerName) {
        this.customerNameTagList = [
          {
            label: customerName,
            value: 'customerName',
          },
        ];
      } else {
        this.customerNameTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseCustomerName() {
      this.formSearch.customerName = '';
      this.onCustomerNameChange();
    },
    async init() {
      this.getDictionaryCodeValue('asm_work_order_type', async () => {
        // 保养
        this.formSearch.caseOrderType = [this.dicCodeValue.asm_work_order_type.upkeep];

        this.getTableList();
      });
    },
    getTableList() {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.$getJSON(apis.caseOrderPage4Portal, this.getReqData()).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
  },
  created() {},
  mounted() {
    this.mergeLanguage(null, 'portal_tab_maintain_order');
    this.getFuncView();
    this.init();
  },
};
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';
.tab-maintain-order {
  .table-content {
    border-radius: 16px;
    background: #fff;
    margin-top: 24px;
    > .header {
      padding: 24px;
      .label {
        color: #1a1a1a;
        line-height: 40px;
        font-weight: bold;
        float: left;
      }
      .search-content {
        float: right;
      }
    }
    .icon-filter {
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        font-size: 14px;
        width: 40px;
        height: 40px;
        color: $--color-text-primary;
        box-shadow: 0 0 0 1.5px #202945 inset;
        border-radius: 50px;
        cursor: pointer;
      }
    .table-bd {
      height: 416px;
      width: 100%;
      overflow: hidden;
      padding: 0 24px;
      margin-top: 24px;
    }

    .page-footer {
      height: 88px;
    }
  }
}
</style>
